import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../commons';
import { GenericResponse, NewContracts } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class NewContractsService {
  newContracts = new BehaviorSubject<GenericResponse<NewContracts>>(null);

  constructor(private http: HttpClient, private config: ConfigService) {}

  getNewContracts(url: string) {
    return this.http.get<GenericResponse>(this.config.getUrl(url)).pipe(
      tap((res: GenericResponse) => {
        this.newContracts.next(res);
      })
    );
  }
}
